import { toRaw } from 'vue';
import { isEmptyGraph } from '../graph/graphModel.js';
import { compileHassGraph, mergeHassConfig } from './hassCompiler.js';
import { createPageHassContext, findHassPage, pageHassObjects } from './pageHass.js';

// Compiled flow per graph; reused while the graph and the page's object ids are unchanged.
const compiledByGraph = new WeakMap();

/** Compile a page's flow graph (see compileHassGraph), cached per graph and object ids. */
export function compilePageHass(page) {
    page = toRaw(page);
    if (!page?.hass || isEmptyGraph(page.hass)) return null;
    const key = `${page.haspid}|${pageHassObjects(page).map(node => `${node.id()}:${node.obj}:${node.haspid}`).join(',')}`;
    const cached = compiledByGraph.get(page.hass);
    if (cached?.key === key) return cached.result;
    const result = compileHassGraph(page.hass, createPageHassContext(page));
    compiledByGraph.set(page.hass, { key, result });
    return result;
}

/**
 * The Home Assistant configuration a UI object exports: its stored
 * `hass_config` merged with what its page's flow graph compiles to for it
 * (see mergeHassConfig). Use this wherever the HASSBuilder's `hass_config`
 * used to be read for export or display.
 */
export function getEffectiveHassConfig(node) {
    const raw = toRaw(node);
    const page = findHassPage(raw);
    const compiled = page ? compilePageHass(page)?.objects.get(raw.id?.()) : undefined;
    return mergeHassConfig(raw?.hass_config, compiled, { page_id: page?.haspid, hasp_id: raw?.haspid, object: raw });
}
